export default function defaultSecure() {
  if (typeof process.env.UNION_MEMBERSHIP_SECURE_COOKIE !== 'undefined') {
    return process.env.UNION_MEMBERSHIP_SECURE_COOKIE === 'true';
  }

  return process.env.NODE_ENV === 'production';
}